export default __webpack_public_path__ + "static/media/wasabipaste.6a1de1d6.PNG";